import Vue from "vue";
import axios from 'axios';
import App from "./app.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import vuetify from "./plugins/vuetify";
import DatetimePicker from "vuetify-datetime-picker";
import CKEditor from "@ckeditor/ckeditor5-vue";
import Donut from 'vue-css-donut-chart';
import 'vue-css-donut-chart/dist/vcdonut.css';

Vue.use(Donut);
Vue.use(CKEditor);
Vue.use(DatetimePicker);

axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (!error || !error.response || error.response.status === 401) {
      console.log("API Error, do logout", error.response.status)
      store.dispatch('logout');
      router.push("/login");
    }
    return Promise.reject(error);
  }
);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount("#app");
